function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#7747C3",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M61.773 267.992l-10.364-9.077c-1.364-1.22-3.454-1.22-4.818 0l-10.364 9.077c-.772.678-1.227 1.672-1.227 2.71v11.878c0 2.981 2.455 5.42 5.455 5.42h17.09c3 0 5.455-2.439 5.455-5.42v-11.878c0-1.038-.455-2.032-1.227-2.71zM52 286h-6v-5.813c0-1.78 1.368-3.187 3-3.187s3 1.453 3 3.188V286zm8.994-3.563c0 1.96-1.611 3.563-3.58 3.563h-3.582v-5.523c0-2.672-2.194-4.81-4.835-4.81-2.686 0-4.835 2.182-4.835 4.81V286h-3.58c-1.97 0-3.582-1.603-3.582-3.563v-11.714c0-.49.224-.98.627-1.336l10.206-8.953c.672-.579 1.701-.579 2.373 0l10.206 8.953c.403.356.627.846.582 1.336v11.714z",
  transform: "translate(-35 -258)"
})));

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d0808022.svg";
export { ForwardRef as ReactComponent };